<script setup lang="ts">
import { IconChevronRightLarge } from '@/features/ui-kit/icons';
import { useProductModals } from '../../business/useProductModals';
import { useProductPage } from '../../business/use-product-page';

const { state } = useProductPage();
const { openTabModal } = useProductModals();

const openModal = (tab: { type: string; value: string }) => {
  openTabModal(tab.type, tab.value);
};
</script>

<template>
  <div class="other-tabs">
    <div v-for="tab in state.tabs" :key="tab.type" class="tab-button" @click="openModal(tab)">
      <span class="tab-title">{{ tab.type }}</span>
      <IconChevronRightLarge :size="16" />
    </div>
  </div>
</template>

<style lang="stylus" scoped>
.other-tabs
  margin-top 32px
  border-radius 20px
  border 1px solid rgba(118, 121, 127, 0.15)
  overflow hidden

.tab-button
  display flex
  justify-content space-between
  align-items center
  padding 16px
  border-bottom 1px solid rgba(118, 121, 127, 0.15)
  cursor pointer
  transition background-color 0.2s ease

  &:last-child
    border-bottom none

  &:hover
    background-color var(--color-background-secondary, #F5F6FA)

  &:active
    background-color var(--color-background-tertiary, #EAECF0)

.tab-title
  font-family Inter
  font-size 16px
  font-weight 400
  line-height 20px
  color var(--text-primary, #1F2026)
</style>
